<template>
  <div>
    <ul class="detalhamento-cirurgia">
      <li>Sua cirurgia está <span class="status-agendado">AGENDADA</span></li>
      <li>
        Veja em sua <a href="/agenda" class="">agenda</a> a data da internação e
        cirurgia
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StatusAgendadaContent',
  props: {
    cirurgia: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.status-agendado {
  color: var(--green);
}

ul.detalhamento-cirurgia {
  list-style: circle;
  text-align: left;
  padding-left: 25px;
  li {
    margin-bottom: 5px;
  }
  a {
    color: var(--blue);
    text-decoration: underline;
  }
}
</style>
